import { render } from "./IndustrialInfo.vue?vue&type=template&id=7b992fbc&ts=true"
import script from "./IndustrialInfo.vue?vue&type=script&lang=ts"
export * from "./IndustrialInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__